/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CustomizeBaseProductForRestaurantQueryVariables = Exact<{
  lineageKey: string;
  restaurantId: string;
}>;

export type CustomizeBaseProductForRestaurantQuery = {
  readonly productForRestaurantByLineageKey: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly slug: string;
    readonly isModifiable: boolean;
    readonly outOfStock: boolean;
    readonly restaurant: {
      readonly __typename: 'Restaurant';
      readonly id: string;
      readonly slug: string;
    };
  } | null;
};

export const CustomizeBaseProductForRestaurantDocument = gql`
  query CustomizeBaseProductForRestaurant($lineageKey: String!, $restaurantId: String!) {
    productForRestaurantByLineageKey(lineageKey: $lineageKey, restaurantId: $restaurantId) {
      __typename
      id
      slug
      isModifiable
      outOfStock
      restaurant {
        __typename
        id
        slug
      }
    }
  }
`;

export function useCustomizeBaseProductForRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<CustomizeBaseProductForRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    CustomizeBaseProductForRestaurantQuery,
    CustomizeBaseProductForRestaurantQueryVariables
  >({ query: CustomizeBaseProductForRestaurantDocument, ...options });
}
